import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { Section } from "@/components/ui/Section";
import { Card } from "@/components/ui/Card";
import { Reveal } from "@/components/common/Reveal";
import { useScrollTo } from "@/hooks/useScrollTo";
import { SERVICES } from "@/utils/constants";

export const Services = () => {
  const scrollTo = useScrollTo();

  return (
    <Section id="services" testId="services-section" bg="charcoal" blueprint blueprintOpacity={0.3}>
      <Reveal>
        <p className="text-weld-glow font-semibold tracking-[0.25em] uppercase text-sm mb-3">What We Do</p>
        <h2 className="font-display text-5xl md:text-6xl text-white">Featured Services</h2>
        <p className="text-white/60 mt-4 max-w-2xl">From urgent on-site repairs to precision custom fabrication — we cut, weld and build it right.</p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Flame;
          return (
            <Reveal key={s.title} delay={(i % 5) * 0.05}>
              <Card className="p-6 h-full flex flex-col group">
                <div className="w-12 h-12 rounded-lg bg-weld/10 border border-weld/30 flex items-center justify-center mb-5 transition-transform group-hover:scale-110 group-hover:rotate-3">
                  <Icon className="text-weld-glow" size={24} />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{s.title}</h3>
                <p className="text-white/55 text-sm leading-relaxed flex-1">{s.text}</p>
                <button
                  data-testid={`service-card-${i}`}
                  onClick={() => scrollTo("contact")}
                  className="mt-4 inline-flex items-center gap-1 text-weld-glow text-sm font-semibold uppercase tracking-wide opacity-80 group-hover:opacity-100 group-hover:gap-2 transition-all"
                >
                  Learn More <ArrowUpRight size={16} />
                </button>
              </Card>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};
